import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import type { SkeletonRadius } from './skeleton';

const toCssSize = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

const shimmer = keyframes`
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
`;

export const StyledSkeletonLine = styled('div')<{ $lineHeight: number | string }>(
  ({ $lineHeight }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: toCssSize($lineHeight),
    flexShrink: 0,
  }),
);

export const StyledSkeleton = styled('div', {
  shouldForwardProp: (prop) => !['$width', '$height', '$radius', '$aspectRatio'].includes(prop),
})<{
  $width: number | string;
  $height: number | string;
  $radius: SkeletonRadius;
  $aspectRatio?: string;
}>(({ theme, $width, $height, $radius, $aspectRatio }) => ({
  width: toCssSize($width),
  height: $aspectRatio ? 'auto' : toCssSize($height),
  aspectRatio: $aspectRatio,
  flexShrink: 0,
  borderRadius: theme.radius[$radius],
  background: `linear-gradient(90deg, ${theme.colors.background.overlay} 25%, ${theme.colors.border.default} 50%, ${theme.colors.background.overlay} 75%)`,
  backgroundSize: '200% 100%',
  animation: `${shimmer} 1.4s infinite linear`,

  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
    background: theme.colors.background.overlay,
  },
}));
